import { render } from "./DosificacionCreate.vue?vue&type=template&id=7d3efdc5&scoped=true"
import script from "./DosificacionCreate.vue?vue&type=script&lang=js"
export * from "./DosificacionCreate.vue?vue&type=script&lang=js"

import "./DosificacionCreate.vue?vue&type=style&index=0&id=7d3efdc5&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3efdc5"]])

export default __exports__